import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const CustomerRequestFilters = ({ filters, onFilterChange }) => {
  const handleFilterChange = (field, value) => {
    onFilterChange({
      ...filters,
      [field]: value,
    });
  };

  const selectStyles = {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E5E7EB",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5652B0",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5652B0",
    },
  };

  return (
    <div className="flex items-center gap-4 flex-wrap">
      {/* Store Type Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Store Type</InputLabel>
        <Select
          value={filters.storeType}
          label="Store Type"
          onChange={e => handleFilterChange("storeType", e.target.value)}
          sx={selectStyles}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="WHOLESALER">Wholesaler</MenuItem>
          <MenuItem value="RETAILER">Retailer</MenuItem>
        </Select>
      </FormControl>

      {/* Status Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Status</InputLabel>
        <Select
          value={filters.status}
          label="Status"
          onChange={e => handleFilterChange("status", e.target.value)}
          sx={selectStyles}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="approved">Approved</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
        </Select>
      </FormControl>

      {/* Sort By Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Sort By</InputLabel>
        <Select
          value={filters.sortBy}
          label="Sort By"
          onChange={e => handleFilterChange("sortBy", e.target.value)}
          sx={selectStyles}>
          <MenuItem value="">None</MenuItem>
          <MenuItem value="firmName_asc">Firm Name (A-Z)</MenuItem>
          <MenuItem value="firmName_desc">Firm Name (Z-A)</MenuItem>
          <MenuItem value="dateCreated_desc">Newest First</MenuItem>
          <MenuItem value="dateCreated_asc">Oldest First</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default CustomerRequestFilters;
